import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

export default function CreateList({ onClose, onListCreated }) {
  const [listName, setListName] = useState('');
  const [listDescription, setListDescription] = useState('');
  const [saving, setSaving] = useState(false);

  async function handleCreateList() {
    if (!listName.trim()) {
      alert('Please enter a list name');
      return;
    }

    setSaving(true);

    try {
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      
      if (userError) throw userError;
      if (!user) {
        alert('You must be logged in to create a list');
        return;
      }

      const { data, error } = await supabase
        .from('contact_lists')
        .insert({
          user_id: user.id,
          name: listName.trim(),
          description: listDescription.trim() || null
        })
        .select()
        .single();

      if (error) throw error;

      alert('List created successfully!');
      onListCreated(data);
      onClose();
    } catch (error) {
      console.error('Error creating list:', error);
      alert('Error creating list: ' + error.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      right: 0, 
      bottom: 0, 
      background: 'rgba(0,0,0,0.5)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      zIndex: 1000 
    }}>
      <div style={{ 
        background: 'white', 
        padding: '30px', 
        borderRadius: '12px', 
        maxWidth: '500px', 
        width: '90%' 
      }}>
        <h2 style={{ 
          fontSize: '24px', 
          fontWeight: '600', 
          color: '#1e293b', 
          marginBottom: '20px' 
        }}>
          Create New List
        </h2>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ 
            display: 'block', 
            fontSize: '14px', 
            fontWeight: '500', 
            color: '#1e293b', 
            marginBottom: '8px' 
          }}>
            List Name *
          </label>
          <input
            type="text"
            placeholder="e.g., Wedding Guests, Holiday Cards"
            value={listName}
            onChange={(e) => setListName(e.target.value)}
            style={{ 
              width: '100%', 
              padding: '12px', 
              border: '2px solid #e2e8f0', 
              borderRadius: '8px', 
              fontSize: '14px' 
            }}
            autoFocus
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ 
            display: 'block', 
            fontSize: '14px', 
            fontWeight: '500', 
            color: '#1e293b', 
            marginBottom: '8px' 
          }}>
            Description (Optional)
          </label>
          <textarea
            placeholder="Add a description for this list..."
            value={listDescription}
            onChange={(e) => setListDescription(e.target.value)}
            rows={3}
            style={{ 
              width: '100%', 
              padding: '12px', 
              border: '2px solid #e2e8f0', 
              borderRadius: '8px', 
              fontSize: '14px',
              fontFamily: 'inherit',
              resize: 'vertical'
            }}
          />
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={handleCreateList}
            disabled={saving}
            style={{ 
              flex: 1, 
              padding: '12px', 
              background: saving ? '#94a3b8' : '#10b981', 
              color: 'white', 
              border: 'none', 
              borderRadius: '8px', 
              cursor: saving ? 'not-allowed' : 'pointer', 
              fontSize: '16px', 
              fontWeight: '500' 
            }}
          >
            {saving ? 'Creating...' : 'Create List'}
          </button>
          <button
            onClick={onClose}
            disabled={saving}
            style={{ 
              flex: 1, 
              padding: '12px', 
              background: '#64748b', 
              color: 'white', 
              border: 'none', 
              borderRadius: '8px', 
              cursor: saving ? 'not-allowed' : 'pointer', 
              fontSize: '16px', 
              fontWeight: '500' 
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}